import { rankWith, uiTypeIs } from '@jsonforms/core'
import { CONTROL_WITH_ADVICE_RENDERER_META } from './ControlWithAdvice'

export default rankWith(3, uiTypeIs(CONTROL_WITH_ADVICE_RENDERER_META.type))
